import React from "react";

import { ResourceAvatar } from "@common/resourceAvatar";
import { Checkbox } from "@common/checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function Resource({ resource, selected, onSelect }: Props) {
  return (
    <div className={styles.resource} onClick={() => onSelect(resource)}>
      <Checkbox isChecked={selected} />
      <div className={styles.avatar}>
        <ResourceAvatar resource={resource} />
      </div>
      <span className={styles.name}>{resource.name}</span>
    </div>
  );
}

export { Resource };
